import { Box, Typography } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import classes from './ModalBox.module.scss';
import { ModalBoxProps } from "../../interfaces/props/ModalBoxProps";

const ModalBox = ({ largeMessage, smallMessage, showSuccessIcon }: ModalBoxProps) => {
  return <Box className={`empty-modal ${classes.box} d-flex flex-column justify-content-center align-items-center`}>
    {showSuccessIcon && (<Box className='py-2'>
      <CheckCircleIcon color='success' fontSize='large' />
    </Box>)
    }
    <Typography className='h5 px-2' align='center' gutterBottom>
      {largeMessage}
    </Typography>
    <Typography className='text-subtitle px-2' align='center' gutterBottom>
      {smallMessage}
    </Typography>
  </Box>
};

export default ModalBox;
